module.exports = __webpack_public_path__ + "70904fd7f212fa8ab46ab34a26280007.svg";